import React, { useState } from "react";
import clsx from "clsx";
import styles from "./Button.module.scss";

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  disabled?: boolean;
  variant?: "primary" | "secondary" | "outline";
  loading?: boolean;
  fullWidth?: boolean;
}

const Button: React.FC<Props> = ({
  onClick,
  disabled,
  variant,
  loading: loadingProp,
  children,
  fullWidth,
  ...props
}) => {
  const [loading, setLoading] = useState(false);
  return (
    <button
      onClick={async (e) => {
        if (!onClick) return;
        setLoading(true);
        try {
          await onClick(e);
        } catch (err) {
          console.error(err);
        }
        setLoading(false);
      }}
      disabled={loading || loadingProp || disabled}
      {...props}
      className={clsx(
        styles.button,
        variant === "secondary"
          ? styles.secondary
          : variant === "outline"
          ? styles.outline
          : styles.primary,
        fullWidth && styles.fullWidth,
        props.className,
      )}
    >
      {loadingProp || loading ? (
        <div className={styles.ldsRing}>
          <div />
          <div />
          <div />
          <div />
        </div>
      ) : null}
      <span
        aria-hidden={loading}
        style={{ opacity: loading || loadingProp ? 0 : 1 }}
      >
        {children}
      </span>
    </button>
  );
};

export default Button;
